/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorInstagram from 'base/components/labrador/Instagram';

export const DynamicLabradorInstagram: typeof LabradorInstagram = (props) => {
    return <ErrorBoundary><LabradorInstagram {...props} /></ErrorBoundary>;
}
export type DynamicLabradorInstagramProps = PropsFromComponent<typeof LabradorInstagram>;
